import { TipoSimulacaoEnum } from "../utils/constants";

const mycoinsBot = [
  {
    route: "/",
    botType: "MYCOINS",
    title: "Mycon, o consórcio com a menor taxa do Brasil",
    description: "Oferta para você ir com tudo na sua conquista com o Mycon.",
    indexar: "noindex,nofollow",
    campanhaId: 605,
    compraId: 130,
    empresaId: 58,
    empresaId_pagametade: 99,
    empresaId_reduzida: 0,
    compraId_pagametade: 173,
    compraId_reduzida: 0,
    desconto: true,
    navBar: true,
    tipoTabela: "integral_pagametade",
    brand: "mycon",
    gtmId: "GTM-PVQ72FR",
    siteDomain: "https://simule.mycon.com.br/",
    bannerSrc:
      "https://chabot-cdn.mycon.com.br/mycon/banner-giovanna-mycon.png",
    linkWhatsApp: "https://api.whatsapp.com/send?1=pt_BR&phone=5511940761248",
    tipoPlano: TipoSimulacaoEnum.CREDITO_INTEGRAL,
    shouldUseCoupon: false,
    copyMessage: [
      {
        mensagem:
          "Oi, eu sou o Mycon! E você está prestes a conquistar de uma forma econômica, prática e segura.",
      },
      {
        mensagem:
          "<b>É sem juros, sem entrada</b> e você tem o melhor plano em mãos em poucos cliques.",
      },
    ],
    theme: [
      {
        inputs: {
          color: "#FFFFFF",
          backgroundColor: "#5451fb",
        },
        buttons: {
          color: "#FFFFFF",
          backgroundColor: "#5451fb",
        },
        hostBubbles: {
          color: "#000000",
          backgroundColor: "#F7F8FF",
        },
        guestBubbles: {
          color: "#FFFFFF",
          backgroundColor: "#2e3444",
        },
        backgroundColor: "#3a4156",
      },
    ],
  },
];

export default mycoinsBot;
